module.exports = __webpack_public_path__ + "media/images/games/35gender/nurse-270b93662e49fb8189f2a244e6453490.png";